/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_In_Desktop_RememberInputs */



/**
* | output |
* | --- |
* | "Remember my choice" |
*
* @param {Open_In_Desktop_RememberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_in_desktop_remember = /** @type {((inputs?: Open_In_Desktop_RememberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_In_Desktop_RememberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Souviens-toi de mon choix")
	if (locale === "de") return /** @type {LocalizedString} */ ("Merkt euch meine Wahl")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricorda la mia scelta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Помните о моём выборе?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recuerda mi elección")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("记住我的选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("私の選択を覚えておいてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेरी पसंद याद रखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lembre-se da minha escolha.")
	return /** @type {LocalizedString} */ ("Remember my choice")
});